// Centralised API base URL for AutoPostr.
//
// Reads REACT_APP_BACKEND_URL from the environment so the app follows the
// current deployment (preview vs production) without any code changes.
export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const STRIPE_API_URL = API_URL;

export default API_URL;
